import type { ComparisonStatus } from "src/@types/campaign-comparison";

export type ComparisonStatusFilter = ComparisonStatus | "ALL";

export interface FilterStateCampaignComparison {
  page: number;
  limit: number;
  search: string;
  status: ComparisonStatusFilter;
}

export const DEFAULT_FILTERS: FilterStateCampaignComparison = {
  page: 1,
  limit: 20,
  search: "",
  status: "ALL",
};

const STATUS_VALUES: ComparisonStatusFilter[] = [
  "ALL",
  "SYNCED",
  "DIVERGENT",
  "NOT_FOUND_IN_STORE",
  "UNREACHABLE",
];

export const parseStatusFilter = (
  value: string | null,
): ComparisonStatusFilter =>
  STATUS_VALUES.includes(value as ComparisonStatusFilter)
    ? (value as ComparisonStatusFilter)
    : "ALL";
